export enum TaskTab {
  INFO,
  FINANCE,
  HISTORY,
  FILES,
  LINKED_TASKS
}
